import { initialise as initialiseIdentity } from "./identity";
import { initialise as initialiseBag } from "./bag";
import { initialise as initialiseSavedItems } from "./savedItems";
import { initialise as initialiseFeatures } from "./features";

export const initialise = async (store, context) => {
  // we have to wait for the identity sdk to initialise
  const identity = await initialiseIdentity(store);

  // pull final context values
  const contextValues = context.getWebContext();
  const bagSavedItemsMapping = {
    storeId: contextValues.storeId,
    country: contextValues.browseCountry,
    originCountry: contextValues.geoCountry,
    currency: contextValues.browseCurrency,
    language: contextValues.browseLanguage,
    sizeSchema: contextValues.browseSizeSchema,
    enabledStoreBasedOperation: contextValues.enabledStoreBasedOperation,
    keyStoreDataversion: contextValues.keyStoreDataversion
  };

  // bag and savedItems can be initialised in parallel
  return await Promise.all([
    initialiseBag(bagSavedItemsMapping),
    initialiseSavedItems(bagSavedItemsMapping),
    initialiseFeatures(store, contextValues)
  ]).then(([bag, savedItems, features]) => ({
    identity,
    bag,
    savedItems,
    features
  }));
};



// WEBPACK FOOTER //
// ./client/sdk/index.js